// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");

function jstfEq(a, b) {
  if (a.label === b.label) {
    return Caml_obj.equal(a.args, b.args);
  } else {
    return false;
  }
}

function jstfToStr(jstf) {
  return (jstf.args.join(" ") + " : " + jstf.label).trim();
}

exports.jstfEq = jstfEq;
exports.jstfToStr = jstfToStr;
/* No side effect */
